import { faHardHat } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { AppHeader } from '../../components/header';

import './style.scss';

export const Maintenance = () => {
  return (
    <div>
      <AppHeader title="BALEO" />
      <div className="app-maintenance">
        <FontAwesomeIcon icon={faHardHat} /> Le site est actuellement en
        maintenance
      </div>
    </div>
  );
};
